<template>
    <b-modal
        size="xl"
        id="fn_probe_modal">
        <template slot="modal-header">
            <h4 class="modal-title">Funkciópróba</h4>
            <a class="btn-close" @click="$bvModal.hide('fn_probe_modal')"></a>
        </template>
        <b-container>
            <div v-if="fn_probe_options.length > 0" class="mt-2">
                <div class="row">
                    <div class="col-8">
                        <h4 class="my-2">Tevékenység</h4>
                        <div class="row">
                            <div v-for="i in 2" :key="i" class="col-6">										
                                <div v-for="(option,id) in fn_probe_option_chunks[i-1]" :key="id" class="row mb-4">
                                    <div class="col-2 text-right px-0 text-muted" :class="{'border-top pt-4': option.has_top_hr}">
                                        OK <input
                                            class="form-check-input"
                                            :value="option.id"
                                            type="checkbox"
                                            v-model="fn_probe_checked"
                                            :id="'option'+option.id" 
                                            :disabled="fn_probe_disabled.indexOf(option.id) != -1 || fn_probe_not_applicable" /><br />
                                        <span v-if="option.has_na_option">
                                            N/A <input
                                            class="form-check-input"
                                            :value="option.id"
                                            type="checkbox"													
                                            :id="'option_na_'+option.id" 
                                            v-model="fn_probe_disabled"
                                            :disabled="fn_probe_not_applicable" />												
                                        </span>
                                    </div>
                                    <div class="col-10" :class="{'border-top pt-4': option.has_top_hr}">
                                        <label class="form-check-label" :for="'option'+option.id">{{ option.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 border-top pt-4">
                                <input
                                            class="form-check-input"
                                            :value="100"
                                            type="checkbox"
                                            v-model="fn_probe_not_applicable"
                                            :id="'option100'" 
                                            :disabled="fn_probe_not_applicable_checkbox_disabled" />
                                A funkciópróba nem alkalmazható / nem szükséges										
                            </div>
                        </div>
                    </div>
                    <div class="col-4">
                        <h4 class="my-2">A megjegyzésről email értesítőt kapnak</h4>
                        <ul>									
                            <li v-for="(user,id) in task.addressees" :key="id">{{ user }}</li>
                        </ul>
                        <h4 class="my-2">További értesítendő területvezető</h4>
                        <v-select v-if="location_leads" v-model="fnprobe_location_leader_id" :options="location_leads" label="name" :reduce="(p) => p.id" required>
                            <template #search="{ attributes, events }">
                                <input
                                    class="vs__search"
                                    v-bind="attributes"
                                    v-on="events" />
                            </template>
                        </v-select>
                        <h4 class="my-2">Megjegyzés</h4>
                        <textarea name="fn_probe_comment" v-model="fn_probe_comment" style="width:100%;" rows="10"></textarea>
                        <div class="mt-3">
                            <h3>A mai napon a munkaterületet visszaadom</h3>
                            <p>A munkafolyamatban megfogalmazott feladatot végrehajtottuk. Ha volt érintett gép, gépcsoport, berendezés azok funkciópróbáját a csekklistában látottak alapján elvégeztük. Biztonságos és rendeltetésszerű üzemeltetésre alkalmasak.</p>
                        </div>
                    </div>
                </div>						
            </div>
            <div v-else>
                <loading></loading>
            </div>
        </b-container>
        <template #modal-footer="{cancel}">
                <div class="float-start">
                    <strong>Jelmagyarázat:</strong><br>
                    N/A Nem alkalmazható
                </div>
                <button type="button" class="btn btn-primary float-end" @click="saveFnProbe" :disabled="fnProbeBusy"><i class="fa fa-spinner fa-spin mr-1" v-if="fnProbeBusy"></i>Mentés</button>
                <button type="button" class="btn btn-secondary float-end" @click="cancel()" :disabled="fnProbeBusy">Mégse</button>
            
        </template>
    </b-modal>
</template>

<script>
import Loading from "@/components/Loading";
import Config from "@/apis/Config";


export default {
	components: {
		Loading,
	},
	props: [
		"task",
        "location_leads",
        "location_leader_id"
	],
	data() {
		return {
            loading: false,
            fn_probe_not_applicable: false,
            fnprobe_location_leader_id: this.$props.location_leader_id,
			fn_probe_options: [],
			fn_probe_checked: [],
			fn_probe_disabled:[],
			fn_probe_comment: '',
			fnProbeBusy: false
		};
	},
	created(){
		Config.getConstant('fn_probe_options')
			.then(response => {
				this.fn_probe_options = JSON.parse(JSON.stringify(response.data)).filter(option => option.id != 100);
			});
	},
	computed: {
		user() {
			return this.$store.state.user;
		},
		fn_probe_option_chunks(){
			return this.chunkIntoN(this.fn_probe_options,2);
		},
        fn_probe_not_applicable_checkbox_disabled(){
            return this.fn_probe_checked.length > 0 || this.fn_probe_disabled.length > 0;
        }
	},
	watch: {},
	methods: {
		saveFnProbe(bvModalEvent){
			this.fnProbeBusy = true;
			bvModalEvent.preventDefault();

			if(this.fn_probe_checked.length == 0 && !this.fn_probe_not_applicable){
                this.swal('A csekklista legalább egy pontban pipálandó!');
                this.fnProbeBusy = false;             
                return false;
            }

            if(this.fnprobe_location_leader_id == null){
                this.swal('Nem töltötted ki a területvezetőt');
                this.fnProbeBusy = false;             
                return false;
            }
            if(this.fn_probe_not_applicable){
                this.fn_probe_checked = [100];
            }
            this.$emit(
                'sendClosable', 
                {'fn_probe_checked': this.fn_probe_checked, 'fn_probe_disabled': this.fn_probe_disabled,'fn_probe_comment': this.fn_probe_comment, 'fn_probe_location_lead': this.fnprobe_location_leader_id},
                () => {
                    this.fnProbeBusy = false;
                });
		},

		chunkIntoN(arr, n){
			const size = Math.ceil(arr.length / n);
			return Array.from({ length: n }, (v, i) =>
				arr.slice(i * size, i * size + size)
			);
		},
        swal(message){
            this.$swal({
                toast: true,
                position: 'bottom-right',
                iconColor: 'red',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                icon: 'error',
                title: message
            });
        }
	},
};
</script>